/* eslint-disable max-len */

export const REST_BOX_TO_DEFAULT_VALIDATION_CHECK = {
  DEFAULT: 'Default',
};

export const ERROR_MESSAGES = {
  PLEASE_ENTER_DEFAULT_TO_PROCEED: `Please type Default correctly to proceed`,
};

export const BUTTON_TEXT = {
  EXECUTE: 'Execute',
  GO: 'Go',
};

export const EResetBoxToDefaultActions = {
  DEFAULT_WARNING_MODAL: 'simple',
  WARNING_MODAL_WITH_INPUT: 'advanced',
};

export const MODAL_BODY_TEXT = {
  DEFAULT:
    'You are about to reset all ports, and settings to factory default settings. This will wipe all current configuration settings and device call records and assigned ports. Are You sure you want to continue?',
  SECODARY: `To Proceed, type the word Default `,
};

export const defaultHandlerState = {
  showWarningModalForReset: false,
  modalType: EResetBoxToDefaultActions.DEFAULT_WARNING_MODAL,
  showSecurityModal: false,
};

export const DEFAULT_CURRENT_APN = 'wwan0';
